<template lang="html">
  <!--
  Component to render file <input> element
  - Accepts the following properties:
  [id]

  - Accepts optional callback property:
  [on-file-change]

  @example

  <file-upload
    id="123"
    @on-file-change="onFileChanged"
  />
  -->

  <section>
    <div class="slds-file-selector slds-file-selector_files">
      <div class="slds-file-selector__dropzone solid-line" v-if="!model">
        <input
          class="slds-file-selector__input slds-assistive-text"
          accept="application/zip"
          type="file"
          @change="onFileChanged"
          :id="uploadId"
        /><label class="slds-file-selector__body file-label" :for="uploadId"
          ><span
            class="slds-file-selector__button slds-button slds-button_neutral"
            ><svg class="slds-button__icon slds-button__icon_left">
              <use
                xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#upload"
              ></use></svg
            >{{ $t("selectFileToUpload") }}</span
          ></label
        >
      </div>
      <div v-else class="selected-file">
        <span>{{ model.name }}</span>
        <svg
          class="red-close"
          tabindex="0"
          @keydown.enter.stop="onClickRemoveFile"
          @click="onClickRemoveFile"
        >
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#close"
          />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
  import { v4 as uuidv4 } from "uuid";

  const FILE_EVENT = "on-file-change";

  export default {
    name: "fileUpload",
    props: {
      id: {
        type: String
      }
    },
    computed: {
      uploadId() {
        return this.id ? this.id : "fileUpload-" + uuidv4();
      },
      fileName() {
        return this.model ? this.model.name : "";
      }
    },
    data() {
      return {
        model: null
      };
    },
    methods: {
      onClickRemoveFile() {
        this.model = null;
        if (this.$listeners[FILE_EVENT] || this._events[FILE_EVENT]) {
          this.$emit(FILE_EVENT, { id: this.uploadId, file: this.model });
        }
      },
      onFileChanged(e) {
        const files = e.target.files || e.dataTransfer.files;
        this.model = files.length ? files[0] : null;
        if (this.$listeners[FILE_EVENT] || this._events[FILE_EVENT]) {
          this.$emit(FILE_EVENT, { id: this.uploadId, file: this.model });
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .file-label {
    margin-bottom: 0;
  }

  .red-close {
    fill: var(--SF_ERROR_RED);
    margin-left: 0.5rem;
    width: 1.25rem;
    height: 1.25rem;
    cursor: pointer;
  }

  .selected-file {
    display: flex;
    align-items: center;
  }

  .solid-line {
    border-style: solid;
  }
</style>
